<template lang="pug">
  .middle(v-if="total > 0")
    el-pagination(
      layout='prev, pager, next',
      :total="total",
      :page-size="tamanhoPagina",
      :current-page.async="pagina"
      @current-change="alterarPagina"
    )
</template>

<script>
import CONFIGS from '@/constants/configs'

export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    pagina: {
      type: Number,
      required: true
    },
    tamanhoPagina: {
      type: Number,
      default: CONFIGS.TAMANHO_PAGINACAO
    }
  },

  data () {
    return {
      CONFIGS
    }
  },

  methods: {
    alterarPagina (newPage) {
      return this.$emit('changePage', newPage)
    }
  }
}
</script>

<style>
  .middle {
    display: flex;
    justify-content: center;
    margin-top: 1vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppPaginacao.vue